module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"book:select-ds":"Для начала работы выберите источник данных в панели слева"},"en":{"book:select-ds":"To get started, select a data source in the left pane"}}')
  delete Component.options._Ctor
}
